import { DummyStore } from 'src/stores';

import { ReportsResponse } from '../types';

export namespace SystemUserReportsStore {
  export const reports = new DummyStore<ReportsResponse>();
}
